"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarPrice = void 0;
var react_1 = __importDefault(require("react"));
var CarPrice_module_scss_1 = __importDefault(require("./CarPrice.module.scss"));
var formatPrice_1 = require("../../helpers/formatPrice");
var getPayment_1 = require("../../helpers/car/getPayment");
var CarPrice = function (_a) {
    var price = _a.price, extra = _a.extra;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: CarPrice_module_scss_1.default.car_price__full },
            extra,
            " ",
            (0, formatPrice_1.formatPrice)(price),
            " \u20BD"),
        react_1.default.createElement("br", null),
        react_1.default.createElement("span", { className: CarPrice_module_scss_1.default.car_price__month },
            (0, formatPrice_1.formatPrice)((0, getPayment_1.getPayment)(price, 0, 96, 0)),
            "\u20BD/\u043C\u0435\u0441. \u0431\u0435\u0437 \u0432\u0437\u043D\u043E\u0441\u0430")));
};
exports.CarPrice = CarPrice;
